export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

/** RFC 6266: the encoded `filename*` wins over the plain `filename`; a malformed one is skipped. */
export const dispositionFilename = (disposition: string): string | undefined => {
  const encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.trim().replace(/^"|"$/g, ''));
    } catch {
      /* fall through to the plain form */
    }
  }
  return /(?:^|;)\s*filename="?([^";]+)"?/i.exec(disposition)?.[1];
};
